import { c as _c } from "react/compiler-runtime";
import { useSessionStore } from '@systemeio/util';
import { useEffect } from 'react';
import { toast } from 'shared/components';
import { getEmailRestrictLink } from 'shared/components/dashboard-mail-editor/utils/get-email-restrict-link';
import TransLoco from 'shared/components/trans-loco';
import { pageRoute } from 'shared/constants/routes.constants';
import { MailingStatusEnum } from 'shared/enums/mailing-status-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRouter } from 'shared/hooks/use-router';
import useUser from 'shared/hooks/use-user';
import { useSwrEmailStatusNotification } from 'shared/notifications/hooks/use-swr-email-status-notification';
import { getBlankLinkComponent } from 'shared/utils/get-blank-link-component';
import { getContactSupportLink } from 'shared/utils/get-contact-support-link';
const notificationClosedKey = (page: string) => `emailStatusNotificationClosed:${page}`;
const shouldShowNotificationForPath = (pathname: string) => {
  if (pathname === pageRoute.Dashboard) return pathname;
  const sectionsRoutes = ['/email-statistics', '/newsletters', '/campaigns', '/mailing'] as const;
  return sectionsRoutes.find(route => pathname.includes(route));
};
export const useEmailStatusNotification = () => {
  const $ = _c(20);
  const {
    t
  } = useLocoTranslation();
  const {
    pathname
  } = useRouter();
  const {
    user,
    isWorkspaceOwner
  } = useUser();
  let pageOrSection;
  let t0;
  if ($[0] !== pathname) {
    pageOrSection = shouldShowNotificationForPath(pathname);
    t0 = pageOrSection && notificationClosedKey(pageOrSection);
    $[0] = pathname;
    $[1] = pageOrSection;
    $[2] = t0;
  } else {
    pageOrSection = $[1];
    t0 = $[2];
  }
  const notificationStateKey = t0;
  const notificationState = useSessionStore(notificationStateKey ?? "");
  let t1;
  if ($[3] !== notificationState) {
    t1 = notificationState.getItem();
    $[3] = notificationState;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const isClosed = t1 === true;
  const shouldFetchStatus = Boolean(pageOrSection && isWorkspaceOwner && !isClosed);
  const {
    data: status
  } = useSwrEmailStatusNotification(shouldFetchStatus);
  let t2;
  if ($[5] !== isClosed || $[6] !== isWorkspaceOwner || $[7] !== notificationState || $[8] !== pageOrSection || $[9] !== status || $[10] !== t || $[11] !== user) {
    t2 = () => {
      if (!user) {
        return;
      }
      if (!pageOrSection) {
        return;
      }
      if (!isWorkspaceOwner) {
        return;
      }
      if (!status) {
        return;
      }
      if (isClosed) {
        return;
      }
      const closeNotification = () => notificationState.setItem(true);
      const options = {
        duration: Infinity,
        onClose: closeNotification
      };
      bb35: switch (status.mailingStatus) {
        case MailingStatusEnum.pending:
          {
            toast.info(<TransLoco t={t} i18nKey="dashboard.notifications.email_status.pending" components={{
              a: getBlankLinkComponent(getEmailRestrictLink(user.dashboardLocale))
            }} />, options);
            break bb35;
          }
        case MailingStatusEnum.new_pending:
          {
            toast.info(<TransLoco t={t} i18nKey="dashboard.notifications.email_status.new_user" components={{
              a: getBlankLinkComponent(getEmailRestrictLink(user.dashboardLocale))
            }} />, options);
            break bb35;
          }
        case MailingStatusEnum.blocked:
          {
            toast.info(<TransLoco t={t} i18nKey="dashboard.notifications.email_status.blocked" components={{
              a: getBlankLinkComponent(getContactSupportLink(user.dashboardLocale))
            }} />, options);
            break bb35;
          }
        default:
          {
            return;
          }
      }
    };
    $[5] = isClosed;
    $[6] = isWorkspaceOwner;
    $[7] = notificationState;
    $[8] = pageOrSection;
    $[9] = status;
    $[10] = t;
    $[11] = user;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== isClosed || $[14] !== isWorkspaceOwner || $[15] !== notificationState.setItem || $[16] !== pageOrSection || $[17] !== status || $[18] !== user) {
    t3 = [user, pageOrSection, isWorkspaceOwner, status, notificationState.setItem, isClosed];
    $[13] = isClosed;
    $[14] = isWorkspaceOwner;
    $[15] = notificationState.setItem;
    $[16] = pageOrSection;
    $[17] = status;
    $[18] = user;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  useEffect(t2, t3);
};